
import { parseTinyUrlFiles, ParseResponse } from '@/core/services/admin-service'
import { toast } from '@/core/utils'
import { defineComponent, reactive, toRefs } from 'vue'
import { downloadFile } from '@/core/services/http-service'
import { format } from 'date-fns'

export default defineComponent({
  setup() {
    const state = reactive({
      apiResponse: null as null | ParseResponse
    })

    async function filesChanged(files: File[]) {
      state.apiResponse = await parseTinyUrlFiles(files)
      downloadFile(state.apiResponse.excelReportDownloadUrl, `report_${format(new Date(), 'yyyy-dd-MM--HH-mm-ss')}.xlsx`)
      toast('Downloaded report file')
    }
    return {
      filesChanged,
      ...toRefs(state)
    }
  }
})
